import React, { useState, useEffect } from 'react';
import TopBar from '../../../components/TopBar';
import styles from './popup.module.css';
import { getOption, updateOption } from '../../../api/optionsApi';

const Popup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [showMobilePopup, setShowMobilePopup] = useState(false);
  const [popupDelay, setPopupDelay] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchPopupSettings = async () => {
      try {
        const data = await getOption("popup");
        const mobileData = await getOption("mobile-popup");
        setShowPopup(data?.data?.value?.showPopup || false);
        setShowMobilePopup(mobileData?.data?.value?.showMobilePopup || false);
        setPopupDelay(data?.data?.value?.popupDelay || 0);
      } catch (error) {
        console.log('Failed to load popup settings:', error);
      }
    };

    fetchPopupSettings();
  }, []);

  const handleSave = async () => {
    setLoading(true);
    try {
      const settings = {
        showPopup,
        popupDelay: popupDelay || 0
      };
      const mobileSettings = {
        showMobilePopup,
        popupDelay: popupDelay || 0
      };

      await updateOption("popup", settings);
      await updateOption("mobile-popup", mobileSettings);

    } catch (error) {
      console.error('Failed to save popup settings:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <TopBar />
      <div className={styles.popupContainer}>

        <div className={styles.popupContent}>
          <form onSubmit={(e) => {
            e.preventDefault();
            handleSave();
          }}>
            <div className={styles.formGroup}>
              <label htmlFor="showPopup">Show Desktop Popup</label>
              <div className={styles.toggleSwitch}>
                <input
                  type="checkbox"
                  id="showPopup"
                  checked={showPopup}
                  onChange={(e) => setShowPopup(e.target.checked)}
                  disabled={loading}
                />
                <span className={styles.slider} onClick={() => setShowPopup(!showPopup)}></span>
              </div>
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="showMobilePopup">Show Mobile Popup</label>
              <div className={styles.toggleSwitch}>
                <input
                  type="checkbox"
                  id="showMobilePopup"
                  checked={showMobilePopup}
                  onChange={(e) => setShowMobilePopup(e.target.checked)}
                  disabled={loading}
                />
                <span className={styles.slider} onClick={() => setShowMobilePopup(!showMobilePopup)}></span>
              </div>
            </div>
            <div>
              <div className={styles.formGroup}>
                <label htmlFor="popupDelay">Popup Delay (seconds)</label>
                <input
                  type="number"
                  id="popupDelay"
                  value={popupDelay}
                  onChange={(e) => setPopupDelay(parseInt(e.target.value) || 0)}
                  min="0"
                  max="300"
                  placeholder="Enter delay in seconds"
                  disabled={(!showPopup && !showMobilePopup) || loading}
                />
              </div>
              {(showPopup || showMobilePopup) && popupDelay > 0 && (
                <p className={styles.helpText}>Popup will appear after {popupDelay} seconds</p>
              )}
            </div>

            <div>
              <button className={`${styles.saveButtons} ${styles.saveChangeButton}`} onClick={() => handleSave()}>
                {loading ? <div className='ringLoader'></div> : 'Save Changes'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Popup;